import React from "react";
import { Page, Layout, Card, Text, Button, Stack } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function PlacesHome() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Page>
      <Layout>
        <Layout.Section>
          <Card>
            <div style={{ padding: '40px', textAlign: 'center' }}>
              <Text variant="heading2xl" as="h1">
                {t("places.welcome.title")}
              </Text>
              <div style={{ marginTop: '20px', marginBottom: '30px' }}>
                <Text variant="bodyLg" as="p" color="subdued">
                  {t("places.welcome.subtitle")}
                </Text>
              </div>
              <Stack distribution="center" spacing="loose">
                <Button primary onClick={() => navigate('/places/locations')}>
                  {t("location.index.title")}
                </Button>
                <Button onClick={() => navigate('/places/locations/new')}>
                  {t("location.index.addLocation")}
                </Button>
              </Stack>
            </div>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}

